import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LayoutComponent } from '../../shared/components/layout/layout.component';
import { ProfileComponent } from './profile.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { SecuritySettingsComponent } from './security-settings/security-settings.component';
import { UpdateComponent } from './update/update.component';
import { AuthGuard } from '@auth0/auth0-angular';
import { Auth0GuardService } from 'src/app/core/services/auth0-guard.service';

@NgModule({
  imports: [RouterModule.forChild([
    {
      path: '',
      component: LayoutComponent,
      children: [
        {
          path: '',
          component: ProfileComponent,
          children: [
            {
              path: '',
              component: UserProfileComponent,
              canActivate: [Auth0GuardService],
            },
            {
              path: 'security',
              component: SecuritySettingsComponent
            },
            {
              path: 'update',
              component: UpdateComponent
            },
          ]
        },
      ],
    }])],
  exports: [RouterModule]
})
export class ProfileRoutingModule { }
